export default __webpack_public_path__ + "static/media/pdf.da6fdaef.svg";